import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-changes',
    templateUrl: './confirm-changes.component.html',
    styleUrls: ['./confirm-changes.component.scss']
})
export class ConfirmChangesComponent implements OnInit {
    msg: string;
    content: string;
    showCancelBtn: boolean = true;
    constructor(public dialogRef: MatDialogRef<ConfirmChangesComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit(): void {
        this.msg = this.data['msg'];
        this.content = this.data['content'];

        try {
            this.showCancelBtn = this.data['showCancelBtn'] == undefined || this.data['showCancelBtn'] == null ? true : this.data['showCancelBtn'];
        } catch (error) {
            this.showCancelBtn = true;
        }
    }
    openDialog(): void {}

    closeDialog(closed: boolean) {
        this.data = { msg: this.msg, closed: closed };
        this.dialogRef.close(this.data);
    }
}
